(() => {
  const formatMoney = (cents, moneyFormat) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const amount = (Number(cents || 0) / 100).toFixed(2);
    return `$${amount}`;
  };

  const initSubtotal = (subtotalNode) => {
    if (!subtotalNode || subtotalNode.dataset.subtotalReady === 'true') return;

    subtotalNode.dataset.subtotalReady = 'true';

    const productForm = subtotalNode.closest('product-form-component');
    if (!productForm) return;

    const subtotalPriceEl = subtotalNode.querySelector('[data-subtotal-price]');
    const variantsDataNode = subtotalNode.querySelector('[data-subtotal-variants]');
    const quantityInput =
      productForm.querySelector('.quantity__input') ||
      productForm.querySelector('input[name="quantity"]');

    const variantInput = productForm.querySelector('input[name="id"]');

    if (!subtotalPriceEl || !variantsDataNode || !quantityInput || !variantInput) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsDataNode.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const updateSubtotal = () => {
      const quantity = Math.max(1, Number(quantityInput.value) || 1);
      const selectedVariantId = String(variantInput.value || '');
      const selectedVariant = variants.find((variant) => String(variant.id) === selectedVariantId);

      if (!selectedVariant) return;

      const subtotal = Number(selectedVariant.price || 0) * quantity;
      subtotalPriceEl.innerHTML = formatMoney(subtotal, subtotalNode.dataset.moneyFormat);
    };

    updateSubtotal();

    quantityInput.addEventListener('input', updateSubtotal);
    quantityInput.addEventListener('change', updateSubtotal);
    variantInput.addEventListener('change', updateSubtotal);

    const observer = new MutationObserver(updateSubtotal);
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    document.addEventListener('variant:change', updateSubtotal);
    document.addEventListener('product:variant-change', updateSubtotal);
  };

  const initAllSubtotals = () => {
    document.querySelectorAll('[data-product-subtotal]').forEach(initSubtotal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSubtotals);
  } else {
    initAllSubtotals();
  }

  document.addEventListener('shopify:section:load', initAllSubtotals);
})();